import { render, staticRenderFns } from "./queue-card.vue?vue&type=template&id=5f8db101&scoped=true&"
import script from "./queue-card.vue?vue&type=script&lang=js&"
export * from "./queue-card.vue?vue&type=script&lang=js&"
import style0 from "./queue-card.vue?vue&type=style&index=0&id=5f8db101&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8db101",
  null
  
)

export default component.exports